import React, { FC, useEffect } from "react";
import { Button, Table, Input, Tooltip } from "antd";
import { YhBox } from "@/components/YhBox";
import { usePurchaseRoDetailsModel } from "./purchaseRoDetailsModel";
import { globalPrompt } from "@/components/message";
import { ColumnsType } from "antd/es/table";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { DetailType } from "@/types/ScmEnums";
import { IDetailList } from "../../purchaseRoType"
import { EditableCell, EditableRow } from "@/components/YHEditTable/editTable";
import { IYhFormRef } from "@/components/YhFormBox/Types";
import { formatNum, formatInt, formatIntPoint, formatDiscount } from "@/utils/utils";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import useGlobalModel from "@/model/globalModel";
interface ITopType {
    id: string,
    mode: "add" | "edit" | "look",
    purchasePoDetails: React.MutableRefObject<IYhFormRef | undefined>
}
export const TableBox: FC<ITopType> = ({ id, mode, purchasePoDetails }) => {
    const { setAddModalVisible,
        detailDataSource,
        detailLookList,
        detailAddList,
        detaiAddDataRowKeys,
        detailDataRowKeys,
        detailDataRow,
        setDetailDataRow,
        setDetailAddList,
        setDetailDataRowKeys,
        setDetailDataSource,
        detailDetailList,
        setDetaiAddDataRowKeys,
        setDetaiAddDataRow,
        setMaterialHistoryRow,
        setMaterialHistoryModel,
    } = usePurchaseRoDetailsModel();
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const switchModelViaible = () => {
        purchasePoDetails.current?.validateFields().then(async res => {
            setAddModalVisible(true)
        })
    }
    const action = mode == "look" ? <></> : <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => switchModelViaible()}
        >{Locale["Add Material"]}</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => detailDetailList(mode)}
        >{Locale["Delete Material"]}</Button>
    </>;
    const setHistoryDetail = (record: any) => {
        setMaterialHistoryRow(record)
        setMaterialHistoryModel(true)
    }
    const columns = [
        {
            // title: '序号',
            title: Locale["SN"],
            width: 80,
            render: (t: any, r: any, i: number) => i + 1
        }, {
            // title: '采购单号',
            title: Locale["Purchase Doc No."],
            width: 150,
            dataIndex: 'purchaseCode',
            render: (text: any, record: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '商品编码',
            title: Locale["Material Code"],
            width: 150,
            dataIndex: 'materialCode',
            render: (text: any, record: any) => <Tooltip placement="topLeft" title={text}><p onClick={() => setHistoryDetail(record)} className="ellipsis click-span">{text}</p></Tooltip>,
        }, {
            // title: '商品名称-英文',
            title: Locale['Material Name En'],
            width: 160,
            dataIndex: 'materialNameEn',     
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,                  
        }, {
            // title: '商品名称',
            title: Locale["Material Name"],
            width: 160,
            dataIndex: 'materialName',
       
        }, {
            // title: '采购数量',
            title: Locale["Purchase Qty"],
            width: 160,
            dataIndex: 'purchaseNum',
        }, {
            // title: '采购单价',
            title: Locale["Unit Price"],
            width: 160,
            dataIndex: 'purchasePrice',
        }, {
            // title: '退货数量',
            title: Locale["Return Qty"],
            width: 160,
            dataIndex: 'num',
            editable: mode != "look" ? true : false,
        }, {
            // title: '退货单价',
            title: Locale["Unit Price"],
            width: 160,
            dataIndex: 'price',
            editable: mode != "look" ? true : false,
        }, {
            // title: '退款金额',
            title: Locale["Return Amount"],
            width: 160,
            dataIndex: 'amount',
        }, {
            // title: '已退数量',
            title: Locale["Returned quantity"],
            width: 160,
            dataIndex: 'preturnNum',
        }, {
            // title: '商品品牌',
            title: Locale["Material Brand"],
            width: 120,
            dataIndex: 'brandName',
        }, {
            // title: '仓库',
            title: Locale["Warehouse"],
            width: 160,
            dataIndex: 'warehouseName',
        }, {
            // title: '货位',
            title: Locale["Shelf"],
            width: 160,
            dataIndex: 'shelfCode',
        }, {
            // title: '备注',
            title: Locale["Note"],
            width: 160,
            dataIndex: 'note',
        }
    ];
    const newSelectColumns = () =>
        columns.map((col, index) => {
            return {
                ...col,
                onCell: (record: IDetailList, rowIndex: number) => ({
                    colIndex: index + 1,
                    rowIndex,
                    record,
                    // rules: col.rules,
                    // options: col.options,
                    // editType: col.editType,
                    editable: col?.editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave,
                }),
            }
        })
    const handleSave = (row: IDetailList) => {
        let { num, preturnNum, purchaseNum, price } = row
        console.log(num)
        num = +formatIntPoint(num);
        price = +formatIntPoint(price);
        preturnNum = +formatIntPoint(preturnNum);
        purchaseNum = +formatIntPoint(purchaseNum);
        let surplusNum = purchaseNum - preturnNum //采购数量 - 已退数量

        let newRow = {
            ...row,
            // num: +formatIntPoint(num, surplusNum, "退货数量≥采购数量+已退数量"),
            num: +formatIntPoint(num, surplusNum, Locale["Return Qty ≥ Purchase Qty + Returned Qty"]),
            amount: (num > surplusNum ? 0 : num * price).toFixed(2)
        }
        let newData = mode == "edit" ? detailDataSource : detailAddList;
        const index = newData.findIndex((item) => row.detailsId === item.detailsId);
        const item = newData[index];
        newData.splice(index, 1, { ...item, ...newRow });
        mode == "edit" ? setDetailDataSource([...newData]) : setDetailAddList([...newData])
    }
    const typeList = {
        "add": [...detailAddList],
        "edit": [...detailDataSource],
        "look": [...detailLookList],
    }
    useEffect(() => {
        console.log(detailAddList)
    }, [mode])
    const setTypeDetailDataRowKeysAndRow = async (selectedRowKeys: React.Key[], mode: string) => {
        if (mode == DetailType.add) {
            setDetaiAddDataRowKeys(selectedRowKeys)
        } else if (mode == DetailType.edit) {
            setDetailDataRowKeys(selectedRowKeys)
        }
    }
    const setTypeDetailDataRow = async (selectedRows: IDetailList[], mode: string) => {
        if (mode == DetailType.add) {
            setDetaiAddDataRow(selectedRows)
        } else if (mode == DetailType.edit) {
            setDetailDataRow(selectedRows)
        }
    }
    return (
        <YhBox title={Locale["Mining and return details"]} rightChildren={action}>
            <Table
                rowKey={record => record.detailsId as string}
                rowClassName='editable-row yh-edit-table-tr'
                rowSelection={
                    mode == DetailType.look ? undefined : {
                        selectedRowKeys: mode == DetailType.add ? detaiAddDataRowKeys : detailDataRowKeys, //记录选中
                        onChange: (selectedRowKeys: React.Key[], selectedRows: IDetailList[]) => {
                            setTypeDetailDataRowKeysAndRow(selectedRowKeys, mode)
                            setTypeDetailDataRow(selectedRows, mode)
                        },
                        onSelectAll: (selected, selectedRows, changeRows) => {
                            setTypeDetailDataRow(selectedRows, mode)
                        }
                    }}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                columns={newSelectColumns() as ColumnsType<IDetailList>}
                dataSource={typeList[mode] as IDetailList[]}
                pagination={false}
                scroll={{ x: 'max-content', y: 290 }}
            />
        </YhBox>
    )
}